class QueryParser {
  private parenthesesCount = 0;
  private inSingleQuote = false;
  private inDoubleQuote = false;

  updateState(char: string): void {
    if (char === "'" && !this.inDoubleQuote) {
      this.inSingleQuote = !this.inSingleQuote;
    } else if (char === '"' && !this.inSingleQuote) {
      this.inDoubleQuote = !this.inDoubleQuote;
    } else if (!this.inQuotes()) {
      if (char === '(') this.parenthesesCount++;
      if (char === ')') this.parenthesesCount--;
    }
  }

  inQuotes(): boolean {
    return this.inSingleQuote || this.inDoubleQuote;
  }

  atTopLevel(): boolean {
    return this.parenthesesCount === 0 && !this.inQuotes();
  }
}

const findMainSelect = (query: string): string => {
  if (!query.toUpperCase().startsWith('WITH ')) {
    return query;
  }

  const parser = new QueryParser();

  for (let i = 5; i < query.length - 6; i++) {
    parser.updateState(query[i]);

    if (
      parser.atTopLevel() &&
      query.slice(i, i + 7).toUpperCase() === 'SELECT ' &&
      (i === 0 || /\s/.test(query[i - 1]))
    ) {
      return query.slice(i);
    }
  }

  return query;
};

const findFromPosition = (afterSelect: string): number => {
  const parser = new QueryParser();

  for (let i = 0; i < afterSelect.length - 4; i++) {
    parser.updateState(afterSelect[i]);

    if (
      parser.atTopLevel() &&
      afterSelect.slice(i, i + 5).toUpperCase() === 'FROM ' &&
      (i === 0 || /\s/.test(afterSelect[i - 1]))
    ) {
      return i;
    }
  }

  return -1;
};

const parseColumns = (columnsSection: string): string[] => {
  const columns: string[] = [];
  const parser = new QueryParser();
  let currentColumn = '';

  for (const char of columnsSection) {
    parser.updateState(char);

    if (char === ',' && parser.atTopLevel()) {
      columns.push(currentColumn.trim());
      currentColumn = '';
    } else {
      currentColumn += char;
    }
  }

  if (currentColumn.trim()) {
    columns.push(currentColumn.trim());
  }

  return columns;
};

export const extractColumns = (query: string): string[] => {
  const normalizedQuery = query.replaceAll(/\s+/g, ' ').trim();
  const mainSelectQuery = findMainSelect(normalizedQuery);
  const selectMatch = mainSelectQuery.match(/^SELECT\s+/i);
  if (!selectMatch) {
    return [];
  }

  const afterSelect = mainSelectQuery.slice(selectMatch[0].length);
  const fromPos = findFromPosition(afterSelect);
  const columnsSection = fromPos === -1 ? afterSelect.trim() : afterSelect.slice(0, fromPos).trim();

  return columnsSection ? parseColumns(columnsSection) : [];
};
